import axios from 'axios';

const baseUrl = `${process.env.VUE_APP_API_BASEURL}/Registrations`;
const headers = { 'Content-Type': 'application/json' };

export default {
  createRegistration(registration) {
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(baseUrl, registration, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },

  updateRegistration(registration) {
    const url = `${baseUrl}/${registration.id}`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .put(url, registration, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },

  saveRegistration(id) {
    const url = `${baseUrl}/${id}/save`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(url, null, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },

  retrieveRegistration(number, email) {
    const url = `${baseUrl}/retrieve?number=${number}&email=${encodeURIComponent(email)}`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .get(url, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },

  submitRegistration(id, payment) {
    const url = `${baseUrl}/${id}/submit`;
    return new Promise((resolve, reject) => {
      return (
        axios
          .post(url, payment, { headers })
          // get data
          .then((resp) => {
            resolve(resp.data);
          })
          .catch((error) => {
            reject(error);
          })
      );
    });
  },
};
